import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import DateRange from "../../DateRange/DateRange";
import { Table } from "../../Table/Table";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
import { Search_icon, tootltip, view_icon } from "../../../assets/img";
import { URLS } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import moment from "moment";

const BookingTransaction = ({ property_id, from_date, to_date }) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname, state } = useLocation();
  const path = pathname?.replace("/", "");

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [popup, setPopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [reason, setReason] = useState(
    "It's far too easy for someone to make adjustments ",
  );
  const [isOverAll, setOverall] = useState();
  const [isValue, setisValue] = useState({
    service_type: [],
    room_category: [],
  });
  const [status, setStatus] = useState();

  console.log("from_date", from_date, "to_date", to_date);

  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    search: paginationData?.[path]?.search ?? "",
    room_category: paginationData?.[path]?.room_category ?? "",
    service_type: paginationData?.[path]?.service_type,

    property_id: property_id,
  });
  const [owners, setOwners] = useState([]);
  useEffect(() => {
    setSelectedFilter((prev) => ({
      ...prev,
      from: from_date || moment().format("DD-MM-YYYY"),
      to: to_date || moment().format("DD-MM-YYYY"),
    }));
  }, [from_date, to_date]);
  const getProperties = async (pageNumber = 1) => {
    const { from, search, to, service_type, room_category, property_id } =
      selectedFilter;

    let payload = {
      property_id: property_id,
    };
    if ((from && to) || (!from && !to)) {
      payload["from_date"] = from;
      payload["to_date"] = to;
    }
    if (room_category) {
      payload["room_category"] = room_category?.value;
    }
    if (service_type) {
      payload["service_type"] = service_type?.value;
    }
    if (search) {
      payload["search"] = search;
    }
    let res = await post(
      `${URLS.OWNER_OVERALL_PROPERTYTRANSACTION}?page=${pageNumber}`,
      payload,
    );
    if (res?.status === "success") {
      setOverall(res);
      setOwners(res?.data?.bookings);
      const roomcategory_list = res?.data?.room_category_list?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      const servicetype = res?.data?.service_type_list?.map((item) => {
        return { value: item?.id, label: item?.display_name };
      });
      setisValue({
        room_category: roomcategory_list,
        service_type: servicetype,
      });
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
    }
  };
  useEffect(() => {
    getProperties();
  }, []);
  const handleReason = () => {
    if (!reason) {
      toast.error("Enter Reason");
      return;
    }
    setStatusPopup(false);
  };

  const handleChange = (ind, key_name, value) => {
    let temp = [...owners];
    temp[ind] = {
      ...temp[ind],
      [key_name]: value,
    };
    setOwners(temp);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Transaction Date",
        accessor: "transaction_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Transaction ID",
        accessor: "transaction_id",
        Cell: ({ value, row }) => {
          return <p className="primary pointer">{value}</p>;
        },
      },
      {
        Header: "Booking ID",
        accessor: "booking_id",
        Cell: ({ value, row }) => {
          return <p className="primary pointer">{value}</p>;
        },
      },
      {
        Header: "Service Type",
        accessor: "service_type",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Room Type",
        accessor: "room_type",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Property Price",
        accessor: "property_price",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Paid Amount",
        accessor: "paid_amount",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Balance Amount",
        accessor: "balance_amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Slot",
        accessor: "slot",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Current Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <button
              value={value}
              onChange={(e) => {
                const value = e.target.value;
                handleChange(row.index, "current_status", value);
                // setCurrentStatus(value);
              }}
              className="active-btn fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 w-100 p-2"
            >
              {value == "1"
                ? "Upcoming"
                : value == "2"
                  ? "Check In"
                  : value == "3"
                    ? "Upcoming"
                    : value}
            </button>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex gap-2 ac-js">
              <button
                value={value}
                onChange={(e) => {
                  setStatus(e.target.value);
                  handleChange(row.index, "status_booking", e.target.value);
                }}
                className={`${
                  value === "User Booked"
                    ? "active-btn"
                    : value === "Auto Cancelled" ||
                        value == "User Cancelled" ||
                        value?.includes("Cancelled")
                      ? "deactive-btn"
                      : value === "Hold"
                        ? "hold-btn"
                        : "release-btn"
                } fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 p-2`}
                style={{ width: "130px" }}
              >
                <p
                  className="text-wrap text-white"
                  style={{ lineHeight: "15px" }}
                >
                  {value}
                </p>
              </button>
              {(value == "Cancelled" || value == "Hold") && (
                <img
                  onClick={() => setStatusPopup(value)}
                  src={tootltip}
                  className="tooltip-icon"
                  alt=""
                />
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
                <button
                  onClick={() => {
                    navigate("/booking-list-view", {
                      state: { type: "edit", booking_id: value },
                    });
                    // navigate("/room-transaction-view", {
                    //   state: { type: "view", booking_id: value },
                    // });
                    // AdminView(row.original.id, "edit");
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
                {/* )} */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [owners, page],
  );

  console.log("isOverAll", isOverAll);
  const handleChangeFilter = (name, val) => {
    let { from, to } = selectedFilter;
    if ((from && to) || (from && !to)) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  useEffect(() => {
    const { search, room } = selectedFilter;
    getProperties(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
        search: search,
        room: room,
      },
    }));
  }, [
    selectedFilter.search,
    selectedFilter.room_category,
    page,
    selectedFilter.service_type,
    selectedFilter.property_id,
    selectedFilter,
  ]);
  return (
    <div>
      <div className="d-flex ac-jb w-100">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{isOverAll?.count}
        </h2>
        <div className="d-flex gap-3 w-50">
          <div className="roles-bg w-65 rounded-4">
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              Property Name: {isOverAll?.data?.property?.property_name}
            </h2>
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Property ID: {isOverAll?.data?.property?.property_id}
            </h2>
          </div>
          <div className="roles-bg w-65 rounded-4">
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              Owner Name: {isOverAll?.data?.property?.owner_name}
            </h2>
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Owner ID: {isOverAll?.data?.property?.owner_id}
            </h2>
          </div>
        </div>
      </div>
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
        <DateRange
          fromValue={selectedFilter.from}
          toValue={selectedFilter.to}
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={isValue?.service_type || []}
          //   value={city}
          //   onChange={setCity}
          value={selectedFilter?.service_type}
          onChange={(e) => {
            handleChangeFilter("service_type", e);
          }}
          placeholder={"Service Type"}
        />
        <Select
          className="location-search"
          options={isValue?.room_category || []}
          //   value={state}
          //   onChange={setState}
          value={selectedFilter?.room_category}
          onChange={(e) => {
            handleChangeFilter("room_category", e);
          }}
          placeholder={"Room Categories"}
          styles={{ width: "200px" }}
        />
        <div className="search-input">
          <input
            //  onChange={(e) => (adminList(1, e.target.value))}
            type="text"
            placeholder="Search"
            value={selectedFilter?.search}
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            style={{ border: "none", width: "150px" }}
          />
          <img src={Search_icon} className="search here" />
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />

      {statusPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4 ">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setStatusPopup(false);
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  text-start">
                  {statusPopup == "2"
                    ? "Reason for cancel ?"
                    : statusPopup == "3"
                      ? "Hold Reason ?"
                      : statusPopup == "4"
                        ? "Reason for Release ?"
                        : ""}
                </p>
                <textarea
                  className="input-box mt-1 w-100"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Describe..."
                />
              </div>
            </div>
            <div className="d-flex ac-jc  mt-5">
              <button onClick={() => handleReason()} className="submit-btn">
                submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingTransaction;
